import {Component, OnInit, ViewChild} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';

export interface FoodPlanHistoryData {
  food: string;
  plan: string;
  times: string;
  days: string[];
  status: string;
}

@Component({
  selector: 'app-foodplan-history',
  templateUrl: './foodplan-history.component.html',
  styleUrls: ['./foodplan-history.component.css']
})

export class FoodplanHistoryComponent implements OnInit {

  displayedColumns: string[] = ['food', 'plan', 'times', 'days', 'status'];
  dataSource = new MatTableDataSource<FoodPlanHistoryData>();
  data: LogsData[];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
  );
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _bkoffService: BackOffServiceService
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    var DATA : FoodPlanHistoryData[] = [];

    this._bkoffService.getPastFoodPlanHistory().then((res) => {
      this.data = res;
      console.log(res);
      this.data.forEach(element => {
        var plan = element.foodplan;
        plan = (plan.split(" "))[0];

        var trimmedDays = [];
        for (var d in element.days) {
          var s = element.days[d].split(" ");
          if (s[0].substr(0, 1) === "0") {
            trimmedDays.push(" " + s[0].substr(1));
          } else {
            trimmedDays.push(" " + s[0]);
          }
        }

        DATA.push({food: element.plannedFood,
                   plan: plan,
                   times: element.plannedTimes,
                   days: trimmedDays,
                   status: element.foodStatus});
      });  
      this.dataSource = new MatTableDataSource<FoodPlanHistoryData>(DATA);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    });

  }

}
